import React from "react";
import { useTranslation } from 'react-i18next';
import propertiesSectionData from "../data/propertiesSectionData";
import { Link } from "react-router-dom";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function PopularProperties() {
  const { t } = useTranslation();
  UseScrollAnimation();
  
  const showData = propertiesSectionData.slice(0, 6).map((el, index) => {
    return (
      <div key={index} className="js-scroll fade-top w-100 w-[31%] h-[500px] rounded-[8px] shadow-md">
        <Link to={`/landDetailes/${el.id}`} className="w-full h-[250px]">
          <img
            src={el.mainImage}
            alt={el.title}
            className="w-full h-[250px] rounded-t-[8px]"
          />
        </Link>
        <div className="p-[15px] h-[50%] flex flex-col justify-between gap-[10px]">
          <div className="h-full flex flex-col gap-[15px] justify-between">
            <div className="flex flex-col gap-[4px]">
            <div className="font-bold text-[#0B2C3D]">{t(`${el.price}`)}</div>
              <div className="font-bold text-[17px]">{t(`${el.title}`)}</div>
              <div className="flex items-center gap-[5px]">
                <img className="w-[15px] h-[15px]" src={require("../../assets/icons/prop-location.svg").default} alt="" />
                <div>{t(`${el.countries}`)}, {t(`${el.city}`)}</div>
              </div>
            </div>
            <div className="flex items-center gap-[10px]">
              <div className="flex items-center gap-[5px]">
                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/bed.svg").default} alt="" />
                <div>{t(`${el.bedroom}`)}</div>
              </div>
              |
              <div className="flex items-center gap-[5px]">
                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/sqft.svg").default} alt="" />
                <div>{t(`${el.area}`)}</div>
              </div>
            </div>
            <div className="flex items-center justify-between gap-[7px]">
              <Link className="flex items-center gap-[7px] p-2.5 px-4 bg-white shadow-md rounded border-[1px] border-[#0b2c3d]" to={"+966 57 099 9395"}>
                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/phone-prop.svg").default} alt="" />
                <div>{t("Call")}</div>
              </Link>
              <Link className="flex items-center gap-[7px] p-2.5 px-4 bg-white shadow-md rounded border-[1px] border-[#0b2c3d]" to={"mailto:info@ligasos.co"}>
                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/email-prop.svg").default} alt="" />
                <div>{t("Emails")}</div>
              </Link>
              <Link className="flex items-center gap-[7px] p-2.5 px-4 bg-white shadow-md rounded border-[1px] border-[#0b2c3d]" to={"https://wa.link/544zck"}>
                <img className="w-[20px] h-[20px]" src={require("../../assets/icons/whaats-prop.svg").default} alt="" />
                <div>{t("Whatsapp")}</div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  });

  return (
    <section className="relative py-[40px]">
      <div className="main-title">
        <div className="secund js-scroll fade-btm ">{t("Popular Properties")}</div>
      </div>
      <div className="container flex flex-col gap-[20px] items-center justify-center  py-[20px]">
        <div className="flex flex-wrap gap-[20px]">
          {showData}
        </div>
        <Link to={"/properties"} className="js-scroll fade-btm flex items-center gap-[7px] bg-[#0B2C3D] w-fit capitalize py-[8px] px-[30px] rounded-[4px] font-bold text-white">
          {t("show More")}
          <img
            src={require("../../assets/icons/arrow-button.svg").default}
            alt=""
            className="w-[15px] h-[15px]"
          />
        </Link>
      </div>
    </section>
  );
}